<template>
  <v-container>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <b>Criteria</b>
          <template v-slot:actions>
            <v-icon color="primary">
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="elevation-1">
            <v-col cols="6" lg="6">
              <FySelect id="glUtilInterestApportionmentCriteriaFY"
                class="gl-util-interest-apportionment-criteria-fy-select"
                :fyRange="fiscalYearRange"
                v-model="criteriaItem.fiscalYear"
              />
            </v-col>
            <v-col cols="6" lg="6">
              <v-text-field class="glUtilInterestApportionmentCriteriaAmount"
                id="gl-util-interest-apportionment-criteria-amount"
                v-model.number="criteriaItem.interestReceived"
                :label= interestRateOrAmount
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6" lg="6">
              <ClarionDateControl id="glUtilInterestApportionmentCriteriaFromDate"
                :isToggle="false"
                classes="gl-util-interest-apportionment-criteria-fromDt"
                v-model="criteriaItem.fromDate"
                :isRequired="true"
                label="From Date"
              />
            </v-col>
            <v-col cols="6" lg="6">
              <ClarionDateControl id="glUtilInterestApportionmentCriteriaToDate"
                classes="gl-util-interest-apportionment-criteria-toDt"
                :isToggle="false"
                v-model="criteriaItem.toDate"
                :isRequired="true"
                label="To Date"
              />
            </v-col>
          </v-row>
          <v-row class="elevation-1">
            <v-col cols="6" lg="3">
              <v-btn class="glUtilInterestApportionmentCriteriaamountViewReport"
                id="gl-util-interest-apportionment-criteria-view-report"
                rounded
                color="primary"
                @click="calculateInterest"
              >
                <v-icon>{{icons.mdiNote}}</v-icon>
                <span class="ml-4">Calculate Interest</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';
import { mdiNote } from '@mdi/js';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import FySelect from '../../common/FySelect.vue';
import { toFiscalYear, toShortDate, calculateFiscalYears } from '../../../util/shared/tmc-global';

export default {
  components: {
    ClarionDateControl,
    FySelect,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    icons: {
      mdiNote,
    },
    interestRateOrAmount: '',
    criteriaItem: {
      fiscalYear: null,
      fromDate: null,
      toDate: null,
      interestReceived: null,
    },
  }),
  created() {
    this.initCriteria();
  },
  computed: {
    ...mapGetters(['todaysDate']),
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears, false);
      },
      dailySectionTypes: (state) => state.enums.GlTransDailySectionEnum,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('SystemConfig', ['updateConfig', 'loadConfig',
    ]),
    async initCriteria() {
      const glConfig = await this.loadConfig({ requiredScope: 'glConfig' });
      const interestRateOrAmount = (glConfig || [])[0].configuration.useRateToCalculateInterest;
      this.interestRateOrAmount = (interestRateOrAmount || false)
        ? 'Interest Rate' : 'Interest Amount';
      this.criteriaItem.fiscalYear = toFiscalYear(new Date(this.todaysDate));
      this.criteriaItem.fromDate = toShortDate(this.todaysDate);
      this.criteriaItem.toDate = toShortDate(this.todaysDate);
      this.criteriaItem.interestReceived = 0.0;
    },
    calculateInterest() {
      /* TODO - Current not figure-out why 'criteriaState' is not working with v-model */
      this.criteriaState = this.criteriaItem;
      this.$emit('viewInterestApportionmentReport');
    },
  },
};
</script>
